<div
  class="login-container"
  [ngClass]="{
    'step-1-height': currentStep === 1,
    'step-2-height': currentStep === 2
  }"
>
  <img src="../../assets/images/logos/credebt-logo.png" alt="img" class="login-logo" />
  <div
    class="login-box"
    [ngClass]="{
      'step-1-width': currentStep === 1,
      'step-2-width': currentStep === 2
    }"
  >
    <div class="login-header">
      <h2>APPLICATION FORM</h2>
    </div>

    <form [hidden]="!(entityForm && currentStep === 1)" [formGroup]="entityForm">
      <div class="custom-dd-height">
        <div class="row">
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <div class="d-flex justify-content-between">
                  <label for="firstName" class="form-title"><span class="required">*</span>First Name</label>
                </div>
              </div>
              <input
                id="firstName"
                type="text"
                class="form-control ft-width"
                placeholder=""
                formControlName="firstName"
              />
              <app-form-error-component [control]="entityForm.controls['firstName']" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <div class="d-flex justify-content-between">
                  <label for="lastName" class="form-title"><span class="required">*</span>Last Name</label>
                </div>
              </div>
              <input
                id="lastName"
                type="text"
                class="form-control ft-width"
                placeholder=""
                formControlName="lastName"
              />
              <app-form-error-component [control]="entityForm.controls['lastName']" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="mobile" class="form-title"><span class="required">*</span>Mobile</label>
                <div class="d-flex">
                  <input
                    id="mobileCountryCode"
                    type="text"
                    class="form-control ft-width inputNumberText me-1"
                    placeholder=""
                    formControlName="mobileCountryCode"
                    maxlength="4"
                    (input)="preventCharcter($event)"
                  />
                  <input
                    id="mobileAreaCode"
                    type="text"
                    class="form-control ft-width inputNumberText me-1"
                    placeholder=""
                    formControlName="mobileAreaCode"
                    maxlength="4"
                    (input)="preventCharcter($event)"
                  />
                  <input
                    id="mobileNumber"
                    type="text"
                    class="form-control ft-width inputNumberText me-1"
                    placeholder=""
                    formControlName="mobileNumber"
                    maxlength="9"
                    (input)="preventCharcter($event)"
                  />
                </div>
              </div>
              <app-form-error-component [control]="entityForm.controls['mobileNumber']" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="phoneCountryCode" class="form-title">Phone</label>
                <div class="d-flex">
                  <input
                    id="phoneCountryCode"
                    type="text"
                    class="form-control ft-width inputNumberText me-1"
                    placeholder=""
                    formControlName="phoneCountryCode"
                    maxlength="4"
                    (input)="preventCharcter($event)"
                  />
                  <input
                    id="phoneAreaCode"
                    type="text"
                    class="form-control ft-width inputNumberText me-1"
                    placeholder=""
                    formControlName="phoneAreaCode"
                    maxlength="4"
                    (input)="preventCharcter($event)"
                  />
                  <input
                    id="phoneNumber"
                    type="text"
                    class="form-control ft-width inputNumberText me-1"
                    placeholder=""
                    formControlName="phoneNumber"
                    maxlength="9"
                    (input)="preventCharcter($event)"
                  />
                </div>
              </div>
              <app-form-error-component [control]="entityForm.controls['phoneNumber']" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="email" class="form-title"> <span class="required">*</span>Email</label>
                <input id="email" type="text" class="form-control ft-width" placeholder="" formControlName="email" />
              </div>
              <app-form-error-component [control]="entityForm.controls['email']" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <div class="d-flex justify-content-between">
                  <label for="organisation" class="form-title"><span class="required">*</span>Organisation</label>
                </div>
              </div>
              <input
                id="organisation"
                type="text"
                class="form-control ft-width"
                placeholder=""
                formControlName="organisation"
              />
              <app-form-error-component [control]="entityForm.controls['organisation']" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="tradingAs" class="form-title">Trading As</label>
              </div>
              <input
                id="tradingAs"
                type="text"
                class="form-control ft-width"
                placeholder=""
                formControlName="tradingAs"
              />
              <app-form-error-component [control]="entityForm.controls['tradingAs']" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="address1" class="form-title"> <span class="required">*</span>Address 1</label>
                <input
                  id="address1"
                  type="text"
                  class="form-control ft-width"
                  placeholder=""
                  formControlName="address1"
                />
              </div>
              <app-form-error-component [control]="entityForm.controls['address1']" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="address2" class="form-title">Address 2</label>
                <input
                  id="address2"
                  type="text"
                  class="form-control ft-width"
                  placeholder=""
                  formControlName="address2"
                />
              </div>
              <app-form-error-component [control]="entityForm.controls['address2']" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="city" class="form-title"> <span class="required">*</span>City</label>
                <input id="city" type="text" class="form-control ft-width" placeholder="" formControlName="city" />
              </div>
              <app-form-error-component [control]="entityForm.controls['city']" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="state" class="form-title">State/County</label>
                <input id="state" type="text" class="form-control ft-width" placeholder="" formControlName="state" />
              </div>
              <app-form-error-component [control]="entityForm.controls['state']" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="area" class="form-title">Area</label>
                <input id="area" type="text" class="form-control ft-width" placeholder="" formControlName="area" />
              </div>
              <app-form-error-component [control]="entityForm.controls['area']" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="postCode" class="form-title">Post Code</label>
                <input
                  id="postCode"
                  type="text"
                  class="form-control ft-width"
                  placeholder=""
                  formControlName="postCode"
                />
              </div>
              <app-form-error-component [control]="entityForm.controls['postCode']" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="field-group">
              <div class="mt-2">
                <label for="country" class="form-title"> <span class="required">*</span>Country</label>
                <ng-select
                  class="custom-dd-class"
                  id="country"
                  [style.flex]="1"
                  [items]="countriesList"
                  bindLabel="name"
                  bindValue="name"
                  placeholder="All"
                  formControlName="country"
                >
                </ng-select>
              </div>
              <app-form-error-component [control]="entityForm.controls['country']" />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 bottom-fixed">
          <div class="d-flex justify-content-center mt-4">
            <button
              *ngIf="currentStep < totalSteps"
              [disabled]="entityForm.invalid"
              type="button"
              class="btn btn-light btn-custom-footer"
              (click)="nextStep()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </form>

    <form [hidden]="!(entityForm2 && currentStep === 2)" [formGroup]="entityForm2">
      <div class="custom-dd-height">
        <div class="row">
          <div class="width-253 field-group">
            <div class="mt-2">
              <label for="bank" class="form-title">Bank</label>
              <input id="bankName" type="text" class="form-control ft-width" formControlName="bankName" />
            </div>
            <app-form-error-component [control]="entityForm.controls['bankId']" />
          </div>
          <div class="width-264 field-group">
            <div class="mt-2">
              <label for="accountNumber" class="form-title">Bank Account</label>
              <input
                id="accountNumber"
                type="text"
                class="form-control ft-width"
                placeholder="44513401546"
                appOnlyNumber
                formControlName="accountNumber"
                maxlength="34"
              />
            </div>
            <app-form-error-component [control]="entityForm.controls['accountNumber']" />
          </div>
          <div class="width-110 field-group responsive-sortcode">
            <div class="mt-2">
              <label for="sortCode" class="form-title">Sort Code</label>
              <input
                id="sortCode"
                type="text"
                class="form-control ft-width"
                formControlName="sortCode"
                placeholder="12-34-56"
                maxlength="8"
                (input)="formatSortCode($event)"
                (keypress)="allowOnlyNumbers($event)"
              />
            </div>
            <app-form-error-component [control]="entityForm.controls['sortCode']" />
          </div>
          <div class="width-120 field-group responsive-sortcode">
            <div class="mt-2">
              <label for="swiftBic" class="form-title">SWIFT BIC</label>
              <input
                id="swiftBic"
                type="text"
                class="form-control ft-width"
                placeholder="BARCIE2D"
                maxlength="8"
                style="text-transform: uppercase"
                formControlName="swiftBic"
              />
            </div>
            <app-form-error-component [control]="entityForm.controls['swiftBic']" />
          </div>
          <div class="width-284 field-group">
            <div class="mt-2">
              <label for="iban" class="form-title">IBAN</label>
              <input
                id="iban"
                type="text"
                class="form-control ft-width"
                placeholder="IE86BARC99021244513401"
                maxlength="34"
                formControlName="iban"
                style="text-transform: uppercase"
              />
            </div>
            <app-form-error-component [control]="entityForm.controls['iban']" />
          </div>

          <div class="col-md-12 mt-4">
            <div class="field-group">
              <div class="mt-2">
                <label for="bankStatement" class="form-title text-nowrap"> Bank Statement </label>
                <div class="form-group file-upload">
                  <input
                    type="file"
                    class="file-border"
                    id="image_file"
                    #fileUploader_bank
                    (change)="fileChange($event, 'bankStatementFile')"
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                  />

                  <div class="loader_gif" *ngIf="showUploadLoader_bank">
                    <img alt="" width="20px" src="assets/images/icon/loader-1.gif" />
                  </div>

                  <img
                    *ngIf="isSelected_bank && !showUploadLoader_bank"
                    class="ms-1 cursor-pointer"
                    src="assets/images/icon/cross-icon.svg"
                    (click)="clearFileInput(fileUploader_bank, 'bankStatementFile')"
                    alt=""
                    width="10px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-4">
            <div class="field-group">
              <div class="mt-2">
                <label for="bankStatement" class="form-title text-nowrap">
                  <span class="required">*</span> Address Proof
                </label>

                <div class="form-group file-upload">
                  <input
                    type="file"
                    class="file-border"
                    id="image_file"
                    #fileUploader_address
                    (change)="fileChange($event, 'addressProofFile')"
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                  />

                  <div class="loader_gif" *ngIf="showUploadLoader_address">
                    <img alt="" width="20px" src="assets/images/icon/loader-1.gif" />
                  </div>

                  <img
                    *ngIf="isSelected_address && !showUploadLoader_address"
                    class="ms-1 cursor-pointer"
                    src="assets/images/icon/cross-icon.svg"
                    (click)="clearFileInput(fileUploader_address, 'addressProofFile')"
                    alt=""
                    width="10px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-4">
            <div class="field-group">
              <div class="mt-2">
                <label for="idProofFile" class="form-title text-nowrap">
                  <span class="required">*</span> ID Proof
                </label>

                <div class="form-group file-upload">
                  <input
                    type="file"
                    class="file-border"
                    id="image_file"
                    #fileUploader_id
                    (change)="fileChange($event, 'idProofFile')"
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                  />

                  <div class="loader_gif" *ngIf="showUploadLoader_id">
                    <img alt="" width="20px" src="assets/images/icon/loader-1.gif" />
                  </div>

                  <img
                    *ngIf="isSelected_id && !showUploadLoader_id"
                    class="ms-1 cursor-pointer"
                    src="assets/images/icon/cross-icon.svg"
                    (click)="clearFileInput(fileUploader_id, 'idProofFile')"
                    alt=""
                    width="10px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 bottom-fixed">
          <div class="d-flex justify-content-center mt-4">
            <button
              *ngIf="currentStep > 1"
              type="button"
              class="btn btn-light btn-custom-footer"
              (click)="previousStep()"
            >
              Back
            </button>
            <button
              *ngIf="currentStep === totalSteps"
              [disabled]="entityForm2.invalid"
              type="button"
              class="btn btn-light btn-custom-footer ms-2"
              (click)="SubmitForm()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
